var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPauseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2270_1101)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.97917 0C2.55372 0 2.14569 0.16901 1.84485 0.46985C1.54401 0.770689 1.375 1.17872 1.375 1.60417V9.39583C1.375 9.82129 1.54401 10.2293 1.84485 10.5302C2.14569 10.831 2.55372 11 2.97917 11C3.40462 11 3.81264 10.831 4.11348 10.5302C4.41432 10.2293 4.58333 9.82129 4.58333 9.39583V1.60417C4.58333 1.17872 4.41432 0.770689 4.11348 0.46985C3.81264 0.16901 3.40462 0 2.97917 0ZM3.66667 9.39583C3.66667 9.57817 3.59423 9.75304 3.4653 9.88197C3.33637 10.0109 3.1615 10.0833 2.97917 10.0833C2.79683 10.0833 2.62196 10.0109 2.49303 9.88197C2.3641 9.75304 2.29167 9.57817 2.29167 9.39583V1.60417C2.29167 1.42183 2.3641 1.24696 2.49303 1.11803C2.62196 0.9891 2.79683 0.916667 2.97917 0.916667C3.1615 0.916667 3.33637 0.9891 3.4653 1.11803C3.59423 1.24696 3.66667 1.42183 3.66667 1.60417V9.39583Z",
    fill: "#008080"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.02067 0C7.59522 0 7.18719 0.16901 6.88635 0.46985C6.58551 0.770689 6.4165 1.17872 6.4165 1.60417V9.39583C6.4165 9.82129 6.58551 10.2293 6.88635 10.5302C7.18719 10.831 7.59522 11 8.02067 11C8.44612 11 8.85415 10.831 9.15499 10.5302C9.45583 10.2293 9.62484 9.82129 9.62484 9.39583V1.60417C9.62484 1.17872 9.45583 0.770689 9.15499 0.46985C8.85415 0.16901 8.44612 0 8.02067 0ZM8.70817 9.39583C8.70817 9.57817 8.63574 9.75304 8.50681 9.88197C8.37788 10.0109 8.20301 10.0833 8.02067 10.0833C7.83833 10.0833 7.66347 10.0109 7.53454 9.88197C7.4056 9.75304 7.33317 9.57817 7.33317 9.39583V1.60417C7.33317 1.42183 7.4056 1.24696 7.53454 1.11803C7.66347 0.9891 7.83833 0.916667 8.02067 0.916667C8.20301 0.916667 8.37788 0.9891 8.50681 1.11803C8.63574 1.24696 8.70817 1.42183 8.70817 1.60417V9.39583Z",
    fill: "#008080"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2270_1101"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 11,
    height: 11,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPauseIcon);
export default __webpack_public_path__ + "static/media/pause-icon.27bacc43a90094b389a20e0b94aab10d.svg";
export { ForwardRef as ReactComponent };